export type MetricNumberFormat = 'integer' | 'scale';

/**
 * Metric values show at most three significant digits below 1000 and whole numbers above 1000;
 * `'integer'` (NPS) is always whole, `'scale'` always shows exactly three decimal places.
 */
export function formatMetricNumber(value: number, language: string, format?: MetricNumberFormat): string {
  if (format === 'scale')
    return new Intl.NumberFormat(language, { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(value);
  const magnitude = Math.abs(value);
  const options: Intl.NumberFormatOptions =
    format === 'integer' || magnitude >= 1000 || magnitude === 0
      ? { maximumFractionDigits: 0 }
      : { maximumSignificantDigits: 3 };
  return new Intl.NumberFormat(language, options).format(value);
}
